import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

const initOptions = {
  debug: true,
  lng: 'ru',
  fallbackLng: 'ru',
  // Явно указываем default namespace чтобы не загружать несуществующий 'translation'
  defaultNS: 'common',
  interpolation: {
    escapeValue: false
  },
  ns: [
    'common',
    'accountReports',
    'accruals',
    'systemReports',
    'osv',
    'registration',
    'demo',
    'auth',
    'home',
    'invoices',
    'accountApplications',
    'accounts',
    'abonents',
    'acts',
    'debts',
    'payments',
    'cabinet'
    // ВАЖНО: 'residentRequests' здесь СОЗНАТЕЛЬНО отсутствует.
    // i18next на init тянет ВСЕ namespace из options.ns (partialBundledLanguages/preload не заданы),
    // а этот модуль импортируется безусловно в src/index.tsx — значит словарь фичи грузился бы
    // у всех ролей, включая тех, кому раздел «Заявки» недоступен.
    // Словарь догружается по требованию: все компоненты фичи вызывают useTranslation('residentRequests')
    // с явным именем namespace, а их роут-страницы обёрнуты в Suspense (shared/common/Loadable)
    // + корневой Suspense в src/index.tsx — поэтому подгрузка даёт спиннер, а не сырые ключи.
    // Добавляя сюда новый namespace, помни: он попадёт в загрузку у ВСЕХ пользователей.
  ]
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(async (language, namespace, callback) => {
      try {
        const module = await import(`./translations/${namespace}/${language}.json`);

        // ВАЖНО: отдаём именно `default`, а не сам объект модуля.
        //
        // Vite (плагин vite:json, json.namedExports = true по умолчанию) превращает JSON
        // в ES-модуль через dataToEsm: для КАЖДОГО ключа верхнего уровня генерируется
        // `export const <ключ> = ...`, но только если имя ключа — допустимый идентификатор
        // (makeLegalIdentifier из @rollup/pluginutils). Зарезервированные слова JS
        // (public, delete, class, new, default, private, static…) допустимыми не являются —
        // именованный экспорт для них НЕ создаётся, они попадают только в `export default`.
        //
        // Раньше сюда уходил объект модуля целиком, поэтому i18next получал словарь БЕЗ таких
        // секций: ключи из них не находились и t() возвращал сам ключ. Ломалось это не только
        // у заявок (секция `public`), но и в общем словаре — там под тем же ударом секция `delete`.
        //
        // `default` — это исходный JSON целиком, поэтому теряться больше нечему.
        callback(null, module.default ?? module);
      } catch (e) {
        // callback обязателен в ЛЮБОМ случае: пока он не вызван, i18next держит namespace
        // в состоянии «загружается», а useTranslation с Suspense — вечный спиннер.
        // Раньше при не-Error исключении (например, отклонённый промис со строкой)
        // callback не вызывался вовсе и страница зависала на загрузке.
        callback(e instanceof Error ? e : new Error(`i18n: не удалось загрузить ${namespace}/${language}`), null);
      }
    })
  )
  .init(initOptions);
